<template>
  <div class="columns is-multiline is-vcentered is-variable is-1">
    <div class="column is-12-desktop is-6-widescreen">
      <h3 class="title mb-1 is-size-4 is-size-5-mobile">{{ $t('payment.wiretransfer.header') }}</h3>
      <p class="mb-4 is-text-wrap-pretty">{{ $t('payment.wiretransfer.payment_info') }}</p>
    </div>
    <div class="column is-12-desktop is-6-widescreen">
      <b-button name="directBankTransfer" type="is-dark" @click="setBankPayment" class="is-fullwidth">{{ $t('payment.wiretransfer.by_transfer') }}</b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WireTransferButton',
  components: {},
  methods: {
    setBankPayment() {
      this.$store.dispatch('$_checkout/setPaymentMethodWireTransfer')
      this.$emit('next-step')
    },
  },
}
</script>

<style scoped lang="sass"></style>
